import React, { FunctionComponent } from 'react';
import { Switch, Redirect, NavLink, withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Routes } from '../../../../common/enums/Routes';
import PrivateRoute from '../../../../containers/PrivateRoute';
import { getSettingsTabs } from './utils';
import SettingsTab from '../../components/SettingsTab';
import ProfilePane from '../ProfilePane';
import NotificationsPane from '../NotificationsPane';
import MessagesPane from '../MessagesPane';
import UsersPane from '../UsersPane';
import { RoleType } from '../../../../common/enums/RoleType';
import { IAppState } from '../../../../common/models/store/IAppState';
import Icon from '../../../../components/Icon';
import CandidateFormPane from '../../components/CandidateFormPane';
import CandidateFormPreview from '../CandidateFormPreview';
import styles from './styles.module.scss';
import ApiTokensPane from '../ApiTokensPane';
import DefaultCountersPane from '../DefaultCountersPane';
import IntegrationsPane from '../IntegrationsPane';

interface IProps {
  role: RoleType;
}

const SettingsTabs: FunctionComponent<IProps> = ({ role }) => (
  <div className={styles.settingsTabs}>
    <div className="tab">
      <NavLink
        className="tab-link"
        to={Routes.Dashboard}
      >
        <Icon icon="arrowLeft" />
        <FormattedMessage id="settings.back" defaultMessage="Back to home" />
      </NavLink>
    </div>
    {
      getSettingsTabs(role).map(({ name, icon }) => (
        <SettingsTab key={name} name={name} icon={icon} />
      ))
    }
  </div>
);

const Settings: FunctionComponent<IProps & RouteComponentProps> = ({ role, location }) => (
  <>
    {location.pathname !== Routes.CandidateFormPreview && <SettingsTabs role={role} />}
    <div className={styles.settingsPane}>
      <Switch>
        <Redirect exact to={Routes.ProfileSettings} from={Routes.Settings} />
        <PrivateRoute exact path={Routes.ProfileSettings} component={ProfilePane} />
        <PrivateRoute exact path={Routes.NotificationsSettings} component={NotificationsPane} />
        <PrivateRoute exact path={Routes.MessagesSettings} component={MessagesPane} />
        {role !== RoleType.User && (
          <>
            <PrivateRoute exact path={Routes.UsersSettings} component={UsersPane} />
            <PrivateRoute exact path={Routes.ApiTokens} component={ApiTokensPane} />
            <PrivateRoute exact path={Routes.Integrations} component={IntegrationsPane} />
            <PrivateRoute exact path={Routes.DefaultCounters} component={DefaultCountersPane} />
            {role === RoleType.SuperAdmin && (
              <>
                <PrivateRoute exact path={Routes.CandidateFormSettings} component={CandidateFormPane} />
                <PrivateRoute exact path={Routes.CandidateFormPreview} component={CandidateFormPreview} />
              </>
            )}
          </>
        )}
      </Switch>
    </div>
  </>
);

const mapStateToProps = ({ user: { user } }: IAppState) => ({
  role: user?.role as RoleType
});

export default connect(mapStateToProps)(withRouter(Settings));
